<template>
  <nav
    class="mh-bottom-nav fixed bottom-0 left-0 right-0 z-50"
    role="navigation"
    aria-label="Navegación principal"
  >
    <router-link
      v-for="item in navigationItems"
      :key="item.name"
      :to="item.to"
      class="mh-nav-item"
      :class="{ active: isActive(item) }"
      :aria-label="item.label"
      :aria-current="isActive(item) ? 'page' : undefined"
    >
      <NavIcon :name="item.icon" />
      <span class="mh-nav-label" :data-texto="item.name">{{ item.name }}</span>
      <span class="mh-nav-dot" aria-hidden="true" />
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { NavIcon, type NavIconName } from '@pepi/ui'

const route = useRoute()

interface NavigationItem {
  name: string
  to: string
  icon: NavIconName
  label: string
  /** Paths (incluye alias) que activan esta pestaña */
  match: string[]
}

const navigationItems: NavigationItem[] = [
  // Inicio va PRIMERO y es la pantalla de aterrizaje: antes no estaba en la
  // barra, así que desde cualquier otra vista no había forma de volver a ella.
  { name: 'Inicio', to: '/inicio', icon: 'inicio', label: 'Ir a inicio', match: ['/inicio', '/dashboard'] },
  { name: 'Chat', to: '/chat', icon: 'chat', label: 'Ir al chat', match: ['/chat'] },
  { name: 'Agenda', to: '/agenda', icon: 'agenda', label: 'Ver la agenda', match: ['/agenda', '/calendar'] },
  { name: 'Tareas', to: '/tareas', icon: 'tareas', label: 'Ver las tareas', match: ['/tareas', '/tasks'] },
  { name: 'Familia', to: '/familia', icon: 'familia', label: 'Ver la familia', match: ['/familia', '/families'] },
  { name: 'Perfil', to: '/perfil', icon: 'perfil', label: 'Ver mi perfil', match: ['/perfil', '/profile'] },
]

const isActive = (item: NavigationItem): boolean => {
  const path = route?.path
  if (!path) return false
  return item.match.some((p) => path === p || path.startsWith(p + '/'))
}
</script>

<style scoped>
/* Tap feedback */
.mh-nav-item:active {
  transform: scale(0.95);
}
</style>
